import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listNews: [],
  isModalShowed: false,
};

export default createSlice({
  name: "news",
  initialState,
  reducers: {
    toogleNewsModal: (state, action) => {
      return {
        ...state,
        isModalShowed: !state.isModalShowed,
        newsInfo: action.payload,
      };
    },
    fetchNewsSuccess: (state, action) => {
      const { result } = action.payload;
      const newList = result.data.data;
      const currentPage = result.data.current_page;
      return {
        ...state,
        listNews: currentPage === 1 ? newList : [...state.listNews, ...newList],
      };
    },
    fetchNewsDetailSuccess: (state, action) => {
      const { result } = action.payload;
      const newDetail = result.data.data;
      return {
        ...state,
        newDetail: newDetail,
      };
    },
  },
});
